import AppStoreBadges from '@/molecules/AppStoreBadges';
import useFooter from '@/organisms/Footer/useFooter';
import LogoFontSvg from '@/svg/logo_font.svg';
import clx from 'classnames';
import Link from 'next/link';
import LegalMenu from './components/LegalMenu';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { footerConfig, discordConfig, legalFooterConfig, cookiePolicy } = useFooter();
  const { t } = useTranslation();

  return (
    <footer className="bg-sand-100 relative z-[1] [@media(min-width:2000px)]:pt-8 lg:pb-4 pb-24">
      <div className="flex flex-wrap flex-col md:flex-row-reverse items-center justify-center max-w-1200 m-auto px-4 pt-8 gap-8">
        <div
          className={clx(
            'absolute -z-1 inset-0 mt-20 mb-30 sm:mt-10 sm:mb-12 [@media(min-width:1600px)]:mr-32',
            "bg-[url('/bg/brassbug.png')] bg-no-repeat bg-200% sm:bg-contain bg-right-bottom transition-all duration-even-slower",
          )}
        />

        <AppStoreBadges />

        <div className="grow flex flex-col gap-8">
          <Link className="md:mx-0 mx-auto" href="/">
            <LogoFontSvg height="52" />
          </Link>
          <div className="text-center md:text-left flex-col md:flex-row flex gap-4 md:gap-8">
            {footerConfig.map((config) => (
              <div key={config.key}>
                <p className="title-5 pb-3 mb-2 text-neutral-900">{t(config.label)}</p>
                <ul className="flex flex-col gap-2">
                  {config.items?.map((item) => (
                    <li key={item.key}>
                      {item.href && (
                        <Link className="lg-medium text-neutral-800" href={item.href}>
                          {item.acf?.icon && <i className={clx(item.acf.icon, ' mr-2')} />}
                          {t(item.label)}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          {discordConfig?.link && discordConfig.title && (
            <div className="text-center md:text-left flex flex-col gap-3 pb-6">
              <p className="title-3 text-neutral-900">{t(discordConfig.title)}</p>
              <a
                className="lg-medium flex items-center md:flex-row flex-col md:gap-4 gap-3"
                href={discordConfig.link.url}
              >
                <i className={clx(discordConfig.icon, 'text-4xl text-neutral-900')} />
                {t(discordConfig.link.title)}
              </a>
            </div>
          )}
        </div>
        <LegalMenu cookiePolicy={cookiePolicy} items={legalFooterConfig} />
      </div>
    </footer>
  );
};

export default Footer;
